import { useLayoutEffect, useRef, useState } from "react";
import { useIsMobile } from "@/hooks/useIsMobile";
import { computeBalancedMetricGridColumns, METRIC_GRID_GAP_PX } from "./metricGridLayout";

export function useMetricGridBalancedColumns(cardCount: number, minCardWidth?: number) {
  const gridRef = useRef<HTMLDivElement>(null);
  const [balancedColumnCount, setBalancedColumnCount] = useState<number | null>(null);
  const isMobile = useIsMobile();
  const isMdUp = minCardWidth != null ? !isMobile : true;

  useLayoutEffect(() => {
    if (minCardWidth == null || !gridRef.current) {
      setBalancedColumnCount(null);
      return;
    }

    const element = gridRef.current;

    const updateColumnCount = () => {
      if (isMobile) {
        setBalancedColumnCount(null);
        return;
      }

      setBalancedColumnCount(
        computeBalancedMetricGridColumns(cardCount, element.clientWidth, minCardWidth, METRIC_GRID_GAP_PX)
      );
    };

    updateColumnCount();

    const resizeObserver = new ResizeObserver(updateColumnCount);
    resizeObserver.observe(element);

    return () => resizeObserver.disconnect();
  }, [cardCount, minCardWidth, isMobile]);

  return {
    gridRef,
    balancedColumnCount: minCardWidth != null ? balancedColumnCount : null,
    isMdUp
  };
}
